import { Address } from '@app-models';

export class Parent {
    id?: number;
    firstName?: string;
    lastName?: string;
    salutation?: string | null;
    emailAddress?: string;
    phoneNumber?: string;
    addresses?: Address[];
}
